import axios from 'axios';
import { getEnvironmentUrl } from '@/services/environment.helper.js';

export function isAuthenticated() {
    return localStorage.getItem('user') ? true : false;
}
export function getToken() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.tokenAcesso) {
        return 'Bearer ' + user.tokenAcesso;
    } else {
        return null;
    }
}

export function getUser() {

    let stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;

}
export function login(user) {
    //const requestOptions = {
    //    method: 'POST',
    //    headers: { 'Content-Type': 'application/json' },
    //    body: JSON.stringify({ username, password })
    //};

  return axios.post(getEnvironmentUrl() +'/v1/autenticar', user, { headers: {"Content-Type": "application/json","KEY":company},  })
        .then(handleResponse)
        .then(data => {
            let obj = {
                tokenAcesso: data.tokenAcesso,
                name: user.usuario,
                remember: user.remember
            }
            storeUser(obj);
            return obj;            
        })
        .catch(err => {
            return err;
        });
}
export function emailRecovery(email) {
  return axios.post(getEnvironmentUrl() + `/v1/usuarios/${email}/recuperar-senha`,null, { headers: { "Content-Type": "application/json", "KEY": company } });
}  
export function trocar(userData) {
  return axios.put(getEnvironmentUrl() + `/v1/usuarios/recuperar-senha`, userData, { headers: { "Content-Type": "application/json","KEY": company } });
}

export function cadastro(userData){
  return axios.post(getEnvironmentUrl() + `/v1/lojistas`, userData, { headers: { "Content-Type": "application/json","KEY": company } });
}

export function storeUser(user) {
    // login successful if there's a jwt token in the response
    if (user.tokenAcesso) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));
        let date = new Date();
        let utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()));
        let storeDate = JSON.stringify(utcDate);
        localStorage.setItem('lastRefresh', storeDate);

        if(!user.remember) {
            window.onbeforeunload = function() {
                logout();
                return '';
              };
        }
    }
}

export function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    localStorage.removeItem('lastRefresh');
}
export function getLastRefresh() {
    let stored = localStorage.getItem('lastRefresh');
    if (stored) {
        stored = JSON.parse(stored);
        let storedDate = new Date(stored);
        let today = new Date();
        let diffMs = (today - storedDate);

        //var diffDays = Math.floor(diffMs / 86400000); // days
        //var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

        return diffMins;
    }
    return null;
}
function handleResponse(response) {
    const { data, status, statusText } = response;
    
    if (status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload();
    }
    else if (status !== 200 || !data.tokenAcesso) {
        const error = 'Usuário ou senha inválido' || statusText;
        return Promise.reject(error);
    }
    return data;
}

export const company = `${location.host.includes('localhost') ? 'teste': location.host.split('.')[0]}`;

export const companyPath = `sistema.${company}`;